<template>
  <div>
    <div
      v-if="mark"
      class="grading"
      :class="{
        '-upperAverage': mark?.grading === 4,
        '-lowerAverage': mark?.grading === 1,
      }"
    >
      <span
        v-tooltip="{ title: $t('studea_manager.dashboard.go_to_questionnaire') }"
        class="questionnaire__note"
        @click="goToQuestionnaire"
      >
        {{ mark.mark }}
      </span>
    </div>
    <div v-else-if="markSignatory && markSignatory.length && markSignatory.includes(profile) && !mark" class="grading">
      <span
        v-tooltip="{ title: $t('studea_manager.dashboard.go_to_questionnaire') }"
        class="questionnaire__note"
        @click="goToQuestionnaire"
      >
        <FontAwesomeIcon icon="fa-light fa-hourglass-start" />
      </span>
    </div>
    <div v-else-if="profile === 1" class="grading"></div>
    <div v-else class="grading">--</div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import router from "@/router";

export default {
  name: "AccordionMarkProfileComponent",
  components: { FontAwesomeIcon },
  props: {
    mark: {
      type: Object,
      required: false,
      default: () => {},
    },
    markSignatory: {
      type: Array,
      required: true,
    },
    profile: {
      type: Number,
      required: true,
    },
    questionnaire: {
      type: Object,
      required: true,
    },
    triad: {
      type: Object,
      required: true,
    },
  },

  methods: {
    goToQuestionnaire() {
      router.push({
        name: "questionnaire",
        params: {
          triadId: this.triad.id,
          questionnaireId: this.questionnaire.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.grading {
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
  min-height: 21px;

  &.-upperAverage {
    background-color: rgba($green, 0.2);
  }

  &.-lowerAverage {
    background-color: rgba($red, 0.15);
  }
}

.questionnaire__note {
  cursor: pointer;
}
</style>
